import { useLang, t } from "./i18n.jsx";

// Primitive comună — folosită de Login, listele Clienți/Evaluări și de toate
// tab-urile din Evaluare (deci stă în chunk-ul principal, alături de Login,
// ca fiecare chunk lazy s-o poată importa fără s-o mai bundleze separat).
//
// label = text RO literal, la fel ca peste tot în restul aplicației —
// tradus aici o singură dată, ca toate apelurile <Field label="…"> să nu
// mai trebuiască atinse individual.
export function Field({ label, children }) {
  const { lang } = useLang();
  return (
    <div className="field">
      <label>{t(lang, label)}</label>
      {children}
    </div>
  );
}
